<div class="modal-dialog user-search-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<span class="header-label">
				<h4 class="modal-title">{{'modal-user-search_find-user' | translate}}</h4>
			</span>
			<button
				type="button"
				class="close-btn"
				(click)="close()"
				attr.aria-label="{{ 'common_close' | translate }}"
			>
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<form
				class="search-bar"
				[formGroup]="searchForm"
				(ngSubmit)="getUsersBy(searchForm.value.searchQuery)"
			>
				<div class="input-group" role="search">
					<span class="search-txt" translate="common_search"></span>
					<input type="text"
						class="form-control search-input fullstory-ignore"
						[formControl]="searchQuery"
						placeholder="{{'modal-user-search_placeholder-search-user' | translate}}"
						[attr.aria-label]="('modal-user-search_find-user' | translate)">
					<span *ngIf="!searchQuery.value" class="input-group-addon">
						<i class="ficon-search"></i>
					</span>
					<span *ngIf="searchQuery.value" class="input-group-addon search-clear">
						<button type="button" (click)="clearSearch()" [attr.aria-label]="('common_cancel-search' | translate)" class="ficon-app-x clear-search btn-none"></button>
					</span>
				</div>
			</form>

			<div class="table-wrapper">
				<div *ngIf="loading$ | async; else table" class="user-search-spinner">
					<i class="ficon ficon-spinner ficon-spin ficon-4x"></i>
				</div>

				<ng-template #table>
					<mat-table
						#table
						[dataSource]="users$"
					>
						<ng-container matColumnDef="id">
							<mat-header-cell *matHeaderCellDef translate="modal-user-search_id"></mat-header-cell>
							<mat-cell *matCellDef="let user"> {{ user.user_id }} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="name">
							<mat-header-cell *matHeaderCellDef translate="common_user"></mat-header-cell>
							<mat-cell *matCellDef="let user"> {{ user.full_name }} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="email">
							<mat-header-cell *matHeaderCellDef translate="common_email"></mat-header-cell>
							<mat-cell *matCellDef="let user" class="fullstory-ignore"> {{ user.email }} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="lastLogin">
							<mat-header-cell *matHeaderCellDef translate="modal-user-search_last-login"></mat-header-cell>
							<mat-cell *matCellDef="let user">
								{{
									user.last_login_at
										? (user.last_login_at | timeago)
										: ('modal-user-search_has-not-logged' | translate)
								}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="orgs">
							<mat-header-cell *matHeaderCellDef translate="modal-user-search_orgs"></mat-header-cell>
							<mat-cell *matCellDef="let user">
								{{ user.orgs || 'modal-user-search_has-not-roles' | translate }}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="actions">
							<mat-header-cell *matHeaderCellDef translate="modal-user-search_action"></mat-header-cell>
							<mat-cell *matCellDef="let user" class="actions-cell">
								<button
									type="button"
									class="mask-button ficon-app-mask icon-btn"
									(click)="maskAs(user)"
									[matTooltip]="'modal-user-search_login-as' | translate: {user: user.full_name}"
								></button>
								<button
									type="button"
									class="edit-button ficon-app-edit icon-btn"
									(click)="openEditUser(user)"
									[matTooltip]="'modal-user-search_edit-user' | translate"
								></button>
							</mat-cell>
						</ng-container>

						<mat-header-row
							*matHeaderRowDef="[
								'id',
								'name',
								'email',
								'lastLogin',
								'orgs',
								'actions'
							]"
						></mat-header-row>
						<mat-row
							*matRowDef="
								let row;
								columns: ['id', 'name', 'email', 'lastLogin', 'orgs', 'actions']
							"
						>
						</mat-row>
					</mat-table>
				</ng-template>
			</div>
		</div>
		<div class="goreact-modal-footer">
			<button class="primary-btn" (click)="close()" translate="common_close"></button>
		</div>
	</div>
</div>
